module.exports = __webpack_public_path__ + "static/media/icon-close-circle-red.5012cf83.svg";